<template>
	<div class="messenger">

		<!-- MESSENGER CONTACTS -->
		<div class="messenger-contacts kleptos-overflow">

			<!-- DIVIDER -->
			<div class="messenger-contacts-divider">
				<span class="text">Online</span>
			</div>

			<!-- CONTACTS ONLINE -->
			<MessengerContactsGroup
				:data="messengerContacts"
				:group="'online'"
				class="is-online"
			/>

			<!-- DIVIDER -->
			<div class="messenger-contacts-divider">
				<span class="text">Offline</span>
			</div>

			<!-- CONTACTS OFFLINE -->
			<MessengerContactsGroup
				:data="messengerContacts"
				:group="'offline'"
				class="is-offline"
			/>

		</div>

		<!-- SEARCH -->
		<!-- <MessengerSearch/> -->

		<!-- <div class="d-flex">
			<button>Settings</button>
			<button>Online</button>
		</div> -->

	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import MessengerContactsGroup from './MessengerContactsGroup.vue';
	import MessengerSearch from './MessengerSearch.vue';

	export default {
	    components: {
	    	MessengerContactsGroup,
	    	MessengerSearch
	    },
	    props: {

	    },
	    data() {
	        return {

	        }
	    },
	    computed: {
	    	...mapGetters('gameData', {
	    		messengerContacts: 'getAllCharacters'
	    	})
	    }
	}
</script>

<style lang="scss" scoped>

	.messenger {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: calc(100% + #{rem-calc(18)});
		margin-top: rem-calc(-18);
	}

	.messenger-contacts {
		background-color: #d1d1c3;
		border: 2px solid #b9b9b6;
		border-bottom: 0;
		border-right: 0;
		// max-height: 90%;
		height: 100%;
		// margin-bottom: rem-calc(20);
		// max-height: 100%;
	}



	.messenger-contacts-divider {
		position: relative;
		background: orange;
		margin: rem-calc(20 6);
		border-bottom: 1px solid #b9b6a4;
		box-shadow: 0 1px 1px #deded5;

		.text {
			position: absolute;
			top: rem-calc(-8);
			left: calc(50% - #{rem-calc(48/2)});
			width: rem-calc(48);
			// border: 1px solid grey;
			font-size: rem-calc(13);
			font-weight: normal;
			line-height: rem-calc(16);
			text-align: center;
			background-color: #d1d0c2;
		}
	}

</style>